import React from "react";
import { Button, CircularProgress } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { styled } from "@mui/material/styles";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const UploadButton = ({ uploading, onFileSelect }) => (
  <Button
    component="label"
    variant="contained"
    startIcon={uploading ? <CircularProgress size={20} color="inherit" /> : <CloudUploadIcon />}
    disabled={uploading}
  >
    Upload file
    <VisuallyHiddenInput type="file" onChange={onFileSelect} />
  </Button>
);

export default UploadButton;